<template>
  <div style="height: 200px">
   我要办事详情页面
    <!-- Employee Area End -->
  </div>
</template>

<script>
  export default {}
</script>




// WEBPACK FOOTER //
// DoWorkDetail.vue?7313ffd0